var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKitchen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 6H14.4V3C14.4 1.34 13.194 0 11.7 0C10.206 0 9 1.34 9 3H10.8C10.8 2.45 11.205 2 11.7 2C12.195 2 12.6 2.45 12.6 3V6H5.4C6.39 6 7.2 5.1 7.2 4V0H1.8V4C1.8 5.1 2.61 6 3.6 6H0V8H1.8V16H16.2V8H18V6ZM3.6 2H5.4V4H3.6V2ZM3.6 14V8H8.1V14H3.6ZM14.4 14H9.9V8H14.4V14Z",
    fill: "#1DBEB4"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKitchen);
export default __webpack_public_path__ + "static/media/kitchen.eec2d319556df170271b79225e7f8694.svg";
export { ForwardRef as ReactComponent };